import { internalEmailDomains } from '@innovyze/shared-utils';
import { selectUserContext } from '@innovyze/stylovyze';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const internalEmailDomainsSet = new Set(internalEmailDomains);

export default function useInternalUser() {
	const [internalUser, setInternalUser] = useState<boolean>(false);
	const { email } = useSelector(selectUserContext);

	const calculateInternalUser = () => {
		const domain = email.split('@')[1];
		return internalEmailDomainsSet.has(domain);
	};

	useEffect(() => {
		setInternalUser(calculateInternalUser());
	}, [email]);

	return internalUser;
}
